import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InfoField, InfoFieldItem } from '../../../../../components/shared/info-field/info-field';
import { Slider } from '../../../../../components/slider/slider';
import { CarCard } from '../../../../../components/car-card/car-card';
import { TrackClickDirective } from '../../../../../directives/track-click.directive';
import { ReguaSegment } from '../../../../../interfaces/quick-approval.interface';
import { ConfigService } from '../../../../../services/config.service';
import { LeadsDetailsService } from '../../../../../services/leads-details-service.service';
import { FormatterHelperService } from '../../../../../services/helpers/formatter-helper.service';

@Component({
  selector: 'app-lead-details-so',
  standalone: true,
  imports: [InfoField, Slider, CarCard, TrackClickDirective],
  templateUrl: './leads-details-so.html',
  styleUrls: ['../shared/lead-detail-shared.scss', './leads-details-so.scss'],
})
export class LeadsDetailsSo {
  @Input() showQuickApproval = false;
  @Input() sliderLoading = false;
  @Input() sliderValue = 0;
  @Input() reguaSegments: ReguaSegment[] = [];

  @Output() sliderValueChange = new EventEmitter<number>();
  @Output() navigate = new EventEmitter<number>();
  @Output() generateSimulation = new EventEmitter<void>();

  leadInfo: InfoFieldItem[] = [];
  simulationInfo1: InfoFieldItem[] = [];
  simulationInfo2: InfoFieldItem[] = [];
  simulationInfo3: InfoFieldItem[] = [];
  carCardTitle = '';
  carCardAnoModelo = '';
  carCardAnoFabricacao = '';
  carCardTipoUso = '';
  carCardCarImage = '';
  carCardEntrada = '';
  carCardSaldoParcelas = '';
  carCardParcelas = '';

  private readonly invalidSimulationImageFragments = [
    'assets/img/veiculos/nova-oferta/hatch.jpg',
    'assets/img/veiculos/nova-oferta/silhueta',
    'silhueta',
  ];

  @Input() set details(value: any) {
    if (value) {
      this.mapDetails(value);
    }
  }

  constructor(
    private readonly leadsDetailsService: LeadsDetailsService,
    private readonly configService: ConfigService,
    private readonly formatter: FormatterHelperService
  ) {}

  private mapDetails(details: any): void {
    const preAprovado = details.preAprovado;
    this.leadInfo = [
      {
        type: 'image',
        imageUrl:
          preAprovado == 'S'
            ? 'assets/images/preaproved.png'
            : preAprovado == 'N'
              ? 'assets/images/preAprovedYellow.png'
              : 'assets/images/pre_aprovado_cinza.png',
        imageAlt:
          preAprovado == 'S'
            ? 'Pré-aprovado'
            : preAprovado == 'N'
              ? 'Necessita análise'
              : 'Não pré-aprovado',
      },
      { type: 'text', title: 'Nome', info: details.nome || '-' },
      { type: 'text', title: 'CPF', info: this.formatter.CPF(details.cpf) },
      { type: 'text', title: 'Data de Nascimento', info: this.formatter.data(details.dataNascimento) },
      { type: 'text', title: 'Email', info: details.email || '-' },
      { type: 'text', title: 'Celular', info: this.formatter.celular(details.celular) },
      { type: 'text', title: 'CEP', info: details.cep || '-' },
      {
        type: 'image',
        imageUrl: details.renovaMais ? 'assets/images/renewalBlueBig.png' : 'assets/images/renewalGray.png',
        imageAlt: details.renovaMais ? 'RenovaMais' : 'Não RenovaMais',
      },
      { type: 'status', title: 'Status', info: details.statusDoLead || '-', leadId: details.idLead },
      { type: 'text', title: 'DN atual', info: details.dn?.toString() || '-' },
      { type: 'text', title: 'Preferência de contato', info: details.preferenciaContato || '-' },
      { type: 'text', title: 'Data de criação', info: this.formatter.data(details.dataCriacao) },
      { type: 'text', title: 'Origem da simulação', info: details.origemSimulacao || '-' },
    ];

    this.simulationInfo1 = [
      {
        type: 'text',
        title: 'Código da Simulação',
        info: details.codigoSimulacao?.toString() || '-',
      },
      { type: 'text', title: 'Origem da Simulação', info: details.origemSimulacao || '-' },
      { type: 'text', title: 'Data Simulação', info: this.formatter.data(details.dataSimulacao) },
      { type: 'text', title: 'Tipo de Compra', info: details.tipoCompra || '-' },
    ];
    this.simulationInfo2 = [
      { type: 'text', title: 'Valor da Simulação', info: this.formatter.moeda(details.valorSimulacao) },
      { type: 'text', title: 'Valor de Entrada', info: this.formatter.moeda(details.valorEntrada) },
      { type: 'text', title: 'Valor da Parcela', info: this.formatter.moeda(details.valorParcela) },
      { type: 'text', title: 'Parcela Residual', info: this.formatter.moeda(details.valorParcelaResidual) },
    ];
    this.simulationInfo3 = [
      { type: 'text', title: 'Percentual Entrada', info: `${details.percentualEntrada || 0}%` },
      {
        type: 'text',
        title: 'Parcelas',
        info: details.quantidadeParcelas ? `${details.quantidadeParcelas}x` : '-',
      },
      { type: 'text', title: 'Tipo de financiamento', info: details.tipoFinanciamento || '-' },
      { type: 'text', title: 'Marca', info: details.marca || '-' },
    ];

    this.carCardTitle = `${details.modeloCompleto || '-'} ${details.versao || ''}`.trim();
    this.carCardAnoModelo = details.anoModelo?.toString() || '-';
    this.carCardAnoFabricacao = details.anoFabricacao?.toString() || '-';
    this.carCardTipoUso = details.tipoUso || '-';
    this.carCardEntrada = this.formatter.moeda(details.valorEntrada);
    this.carCardSaldoParcelas = this.formatter.moeda(details.valorParcela);
    this.carCardParcelas = `${details.quantidadeParcelas || 0}x`;
    this.sliderValue = details.percentualEntrada || 0;

    this.leadsDetailsService.getSimulacaoDetails(details.codigoSimulacao).subscribe({
      next: (response) => {
        this.carCardCarImage = this.buildSimulationImageUrl(response?.ImagemVeiculo);
      },
      error: () => {
        this.carCardCarImage = '';
      },
    });
  }

  private buildSimulationImageUrl(imagePath: string | null | undefined): string {
    if (!imagePath) {
      return '';
    }

    const normalizedImagePath = imagePath.trim();
    if (!normalizedImagePath) {
      return '';
    }

    const imageUrl = /^https?:\/\//i.test(normalizedImagePath)
      ? normalizedImagePath
      : `${this.configService.getRequiredByPath<string>('bancoVw.imageBaseUrl')}/${normalizedImagePath.replace(/^\/+/, '')}`;
    const normalizedUrl = imageUrl.trim().toLowerCase();

    return normalizedUrl && !this.invalidSimulationImageFragments.some((fragment) => normalizedUrl.includes(fragment))
      ? imageUrl
      : '';
  }
}
